export type Translations = Record<string, string>;

export const DEFAULT_TRANSLATION_LANG = 'FR';

export function getTranslatedValue(
  translations: Translations | string | null | undefined,
  lang: string = DEFAULT_TRANSLATION_LANG,
  defaultLang: string = DEFAULT_TRANSLATION_LANG,
): string {
  if (translations == null) return '';
  if (typeof translations === 'string') return translations;
  const normalizedLang = lang.toUpperCase();
  const normalizedDefault = defaultLang.toUpperCase();
  return translations[normalizedLang] ?? translations[normalizedDefault] ?? '';
}
